import angular from 'angular';
import { wixSdkFactory } from './wixSdk.factory';

export const wixSdkModule = angular
  .module('bit.services.wixSdk', [])
  .factory('wixSdk', wixSdkFactory);
